<form [formGroup]="form">
  <mat-form-field class="w-full">
    @if (!placeholder) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <input
      #input
      matInput
      [attr.aria-label]="aria"
      [appUppercase]="onlyUppercase"
      [formControlName]="controlName"
      [matAutocomplete]="auto"
      (input)="filter()"
      (focus)="onOpened()"
      [placeholder]="placeholder" />
    <mat-icon matPrefix>search</mat-icon>
    @if (inputControl?.value) {
      <button mat-icon-button [disabled]="inputControl?.disabled" matSuffix (click)="clearInput()">
        <mat-icon class="material-icons-outlined cursor-pointer">cancel</mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayOptionsFn"
      [requireSelection]="requireSelection"
      (optionSelected)="onOptionSelected($event)">
      @for (option of filteredOptions(); track option[valueProperty]) {
        <mat-option class="allow-disabled flex" [value]="option[valueProperty]" [disabled]="option.disabled">
          <div class="flex-1">{{ displayOptionsFn(option) }}</div>
          @if (option.sublabel) {
            <div class="text-sm text-[var(--neutral-50)] dark:text-[var(--neutral-70)]">{{ option.sublabel }}</div>
          }
        </mat-option>
      }
    </mat-autocomplete>
    @if (inputControl?.errors) {
      <mat-error>
        <ng-template [appMatErrorMessages]="inputControl" let-message>
          {{ message }}
        </ng-template>
      </mat-error>
    }

    @if (hint && hint.show) {
      <mat-hint [ngClass]="hint.colorClass ?? 'text-secondary-30'" class="mt-1 flex items-center gap-1">
        @if (hint.icon) {
          <span>
            <mat-icon class="text-base" [ngClass]="hint.colorClass ?? 'text-secondary-30'">{{ hint.icon }}</mat-icon>
          </span>
        }
        <span class="mb-0.5">{{ hint.message | translate }} </span>
      </mat-hint>
    }
  </mat-form-field>
</form>
